import useApi from "./useApi";

const useMonthlyRevenue = () => {
  const { get } = useApi();
  return get("/revenue-monthly");
};

export default useMonthlyRevenue;
